"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayrixMerchantStatus = void 0;
var PayrixMerchantStatus;
(function (PayrixMerchantStatus) {
    PayrixMerchantStatus["CREATED"] = "created";
    PayrixMerchantStatus["BOARDING"] = "boarding";
    PayrixMerchantStatus["BOARDED"] = "boarded";
    PayrixMerchantStatus["DENIED"] = "denied";
    PayrixMerchantStatus["FAILED"] = "failed";
    PayrixMerchantStatus["HELD"] = "held";
})(PayrixMerchantStatus = exports.PayrixMerchantStatus || (exports.PayrixMerchantStatus = {}));
